import { genRefId } from './index'
import {
  onCheckCondition,
  searchCondition,
} from 'designer/component/action/condition/Action'
import objectPath from 'object-path'

export const deleteJsonTable = (dataUpdate, propAction) => {
  let { designContext, uischema, updateData = () => {} } = propAction
  let { jsonForm } = designContext
  let formData = jsonForm.formData
  let tableKey = uischema.key
  let hasAfterDeleteRowCondition = searchCondition(jsonForm, tableKey, {
    stateKey: 'isAfterDeleteRow',
  })
  if (hasAfterDeleteRowCondition.length > 0) {
    updateData(dataUpdate)
    onCheckCondition(designContext, formData, tableKey, {
      isDeleteRow: true,
      filterCondition: hasAfterDeleteRowCondition,
    })
  } else {
    updateData(dataUpdate)
  }
}

export const deleteSyncTable = (dataUpdate, propAction) => {
  let {
    designContext,
    updateSyncData = () => {},
    syncKey,
    syncName,
    stateParent,
  } = propAction
  const {
    render: [render, setRender],
  } = stateParent

  let { jsonForm } = designContext
  let formData = jsonForm.formData
  let hasAfterDeleteRowCondition = searchCondition(jsonForm, syncKey, {
    stateKey: 'isAfterDeleteRow',
  })
  if (hasAfterDeleteRowCondition.length > 0) {
    updateSyncData(syncKey, syncName, dataUpdate)
    onCheckCondition(designContext, formData, syncKey, {
      isDeleteRow: true,
      filterCondition: hasAfterDeleteRowCondition,
    })
  } else {
    updateSyncData(syncKey, syncName, dataUpdate)
  }
  setRender(true)
}

export const onRowTableDelete = (oldData, item, propAction) => {
  let {
    designContext,
    uischema,
    stateParent,
    isLoadSYNC,
    syncKey,
    config,
    updateData,
    formComponentName,
  } = propAction
  let { isFavoriteModal, jsonData = [], favoriteDataKey } = config
  let { jsonForm, isUiChanged } = designContext
  let formData = jsonForm.formData
  let editFavorite = isUiChanged?.editFavorite
  let favoriteJson = objectPath.get(editFavorite, `jsonData.${favoriteDataKey}`)

  const {
    loading: [, setLoading],
  } = stateParent
  const columnRefId = objectPath.get(uischema, 'loadData.columnRefId')

  setLoading(true)
  let index = -1
  let tableKey = isLoadSYNC ? syncKey : uischema.key
  let tableName = uischema.name
  tableKey = formComponentName ? `${formComponentName}.${tableKey}` : tableKey
  tableName = formComponentName
    ? `${formComponentName}.${tableName}`
    : tableName
  let arrayTable = objectPath.get(isUiChanged, `arrayTable.${tableKey}`)
  arrayTable = Array.isArray(arrayTable) ? arrayTable : []
  let formTable =
    objectPath.get(formData, tableName) ||
    objectPath.get(formData, tableKey) ||
    objectPath.get(formData, uischema.name) ||
    objectPath.get(formData, uischema.key) ||
    []
  formTable = Array.isArray(formTable) ? formTable : []
  let dataUpdate = isFavoriteModal
    ? favoriteJson || jsonData
    : arrayTable.length > 0
    ? arrayTable
    : formTable

  let genId = objectPath.get(oldData, genRefId)
  let rowId = objectPath.get(oldData, columnRefId)
  if (columnRefId && rowId) {
    index = dataUpdate.findIndex((data) => {
      return objectPath.get(data, columnRefId) === rowId
    })
  } else if (genId) {
    index = dataUpdate.findIndex((data) => {
      return objectPath.get(data, genRefId) === genId
    })
  } else {
    index = dataUpdate.findIndex((data) => {
      let foundUnique = Object.keys(data).find((key) => {
        if (key === 'tableData') return false
        return objectPath.get(data, key) !== objectPath.get(oldData, key)
      })
      if (foundUnique) return false
      return true
    })
  }

  if (index > -1) {
    let { statusValue, statusField, isDeleteMode } = item
    let newData = oldData
    if (genId) {
      objectPath.del(dataUpdate, index)
    } else if (isDeleteMode === 'on' || isDeleteMode === true) {
      if (rowId) {
        objectPath.set(newData, `@isDeleted`, true)
        objectPath.set(newData, statusField, statusValue)
        objectPath.set(dataUpdate, index, newData)
      } else {
        objectPath.del(dataUpdate, index)
      }
    } else {
      objectPath.del(dataUpdate, index)
    }
    if (isFavoriteModal) {
      updateData(dataUpdate)
    } else if (isLoadSYNC) {
      deleteSyncTable(dataUpdate, propAction)
    } else {
      deleteJsonTable(dataUpdate, propAction)
    }
  }
  setLoading(false)
  return Promise.resolve()
}
